import repository from '@/repositories/Repository'

const resource = '/item_categories'

export default {
  get(company, postData) {
    return repository.bizoo
      .post(`${resource}/${company}`, postData)
      .then(r => r.data)
  },
}
